export enum GrantBlockEnum {
  LOCKED_AFTER_PASS = 'LOCKED_AFTER_PASS',
  NO_LIMIT = 'NO_LIMIT',
}
